module.exports = __webpack_public_path__ + "img/PEGASE.ad0d21d1.jpg";